import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { Observable } from 'rxjs';

export interface ShippingValidationResult {
  isShippingAvailable: boolean;
  hasShippingRate: boolean;
  hasUserShippingAddresses: boolean;
  unavailableCountries: string[];
  availableCountries: string[];
  shippingRateDescription: string;
  message: string;
}

export interface UserShippingAddress {
  idAddress: number;
  idCountry: number;
  countryName: string;
  city: string;
  address: string;
  recipientName: string;
}

@Injectable({
  providedIn: 'root',
})
export class ShippingValidationService {

  apiService = inject(ApiService);

  constructor() {}

  validateShippingAvailability(
    articleId: number
  ): Observable<ShippingValidationResult> {
    return this.apiService.requestCached<ShippingValidationResult>(
      ApiServiceHolder.shippingconfiguration.validateShippingAvailability(
        articleId
      )
    );
  }

  getUserShippingAddresses(): Observable<UserShippingAddress[]> {
    return this.apiService.request<UserShippingAddress[]>(
      ApiServiceHolder.shippingconfiguration.getUserShippingAddresses()
    );
  }

}
